export default __webpack_public_path__ + "static/media/Icons_Wallet_Grey Icon.4003989b.svg";